import { InjectionToken } from '@angular/core';
import { DialogConfigBase } from './dialog.model';

export const DIALOG_DEFAULT_CONFIG = new InjectionToken<DialogConfigBase>(
  'DIALOG_DEFAULT_CONFIG'
);
